import { useSelector } from 'react-redux';
import React from 'react';

import InvoicingDataEdit from './invoicingData';
import ContainerSectionMobile from '../../components/containerSectionMobile';
import ContainerSectionDesktop from '../../components/containerSectionDesktop';

import './invoicingDataEditScreen.scss';

const InvoicingDataEditScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);

  return (
    isMobileDevice ? (
      <ContainerSectionMobile className="profile-information">
        <InvoicingDataEdit />
      </ContainerSectionMobile>
    ) : (
      <ContainerSectionDesktop>
        <InvoicingDataEdit />
      </ContainerSectionDesktop>
    )
  );
};

export default InvoicingDataEditScreen;
